export type FairDetailContainerProps = {
  primaryColor?: string
}

export type FairDetailProps = {
  className?: string
} & FairDetailContainerProps

export type ImageDataProps = {
  url: string
  oneToOneImage?: { url: string }
  threeToTwoImage?: { url: string }
  fourToThreeImage?: { url: string }
  sixteenToNineImage?: { url: string }
}

export type BridalFairBase = {
  name: string
  descriptionText: string
  minutes: number | null
  mainImageData: ImageDataProps | null
  pricing?: 'free' | 'paid' | 'partially_paid'
  price?: number | null
  numberOfPeople?: number | null
  pricingDescriptionText?: string | null
  isEdited?: boolean
}

export type BridalSpecialOffersProps = {
  mainImageUrl: string
  mainImageData: ImageDataProps | null
  name: string
  descriptionText: string
  applicableType: string
  applicableFirstVisitStartDate: string
  applicableFirstVisitEndDate: string
  applicableContractStartDate: string
  applicableContractEndDate: string
}[]

export type SpecialOffersProps = {
  primaryColor?: string
  bridalSpecialOffers: BridalSpecialOffersProps
} & Props

export type FairContentsProps = {
  name: string
  descriptionText: string
  imageData: ImageDataProps | null
  fairImages: { imageUrl: string }[]
}[]

export type ContentsProps = {
  fairContents: FairContentsProps
} & Props

export type FairTimesProps = {
  availability: 'lot' | 'few' | 'none'
  startAt: string
}[]

export type Props = {
  className?: string
}

export type IndividuallyEditedFairDetail = {
  particularDate: Date
  name: string
  descriptionText: string
  imageUrl: string
  pricing: 'free' | 'paid' | 'partially_paid'
  price: number | null
  numberOfPeople: number | null
  pricingDescriptionText: string | null
}

export const pricingLabels = {
  free: '無料',
  paid: '有料',
  partially_paid: '一部有料',
} as const
